export default __webpack_public_path__ + "static/2-904b07828b75c1742bb1cdc356b2338e.png";